import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import Typography from '../Typography';

export default function ConfirmDialog({
  open,
  setOpen,
  confirm,
  cancel,
  labelConfirm,
  labelCancel,
  title,
  description,
  styleBody,
  styleTitle,
}) {
  const handleConfirm = () => {
    if (confirm) {
      confirm();
    }
    if (setOpen) {
      setOpen(false);
    }
  };

  const handleCancel = () => {
    if (cancel) {
      cancel();
    }
    if (setOpen) {
      setOpen(false);
    }
  };

  return (
    <div>
      <Dialog
        style={{ zIndex: 99999 }}
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Typography align="center" size="large" p={3} variant="h6" style={styleTitle}>
          {title}
        </Typography>
        <DialogContent>
          <Typography align="center" size="medium" p={3} variant="h6" style={styleTitle}>
            {description}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {labelCancel}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {labelConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  confirm: PropTypes.func,
  cancel: PropTypes.func,
  labelConfirm: PropTypes.string,
  labelCancel: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  styleBody: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  styleTitle: PropTypes.object,
};

ConfirmDialog.defaultProps = {
  open: false,
  setOpen: null,
  confirm: null,
  cancel: null,
  labelConfirm: '',
  labelCancel: '',
  title: '',
  description: '',
  styleBody: {},
  styleTitle: {},
};
